const GTAG_SRC = 'https://www.googletagmanager.com/gtag/js';

export const analyticsArgs = {
    measurementId: import.meta.env.VITE_GA_MEASUREMENT_ID,
};

function isBrowserEnvironment() {
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}

function isAnalyticsLoaded() {
    return isBrowserEnvironment() && typeof window.gtag === 'function';
}

export function initializeAnalytics({ measurementId }) {
    if (!isBrowserEnvironment() || !measurementId || isAnalyticsLoaded()) {
        return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `${GTAG_SRC}?id=${encodeURIComponent(measurementId)}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', measurementId);
}
